import { getSeguroPromise } from "../../../shared/helper/requests";

export function buscarServicoPorSigla(sigla) {
  return getSeguroPromise(`SagService/servico/sigla?sigla=${sigla}`);
}
